import React, { Component } from "react";
import { VideoPropTypes } from "../../constants/classPropTypes";

class OnAir extends Component {
  render() {
    const { video } = this.props;
    const imgBaseURL = `${process.env.REACT_APP_API_BASE_URL}/blob-assets/images/illustrations/community-standup`;
    const TwitchLogo = imgBaseURL +`/twitch.svg`;
    const YoutubeLogo = imgBaseURL +`/youtube-brands.svg`;
    return (
      <>
        <h2>{video.category} Live Show</h2>
        <h3>Topic: {video?.displayTitle ? video.displayTitle : video.title}</h3>
        <div className="col-lg-8 offset-lg-2 embed-responsive embed-responsive-16by9">
          <iframe
            title={video.title}
            className=" embed-responsive-item"
            src={`https://www.youtube-nocookie.com/embed/${video.videoId}?autoplay=1`}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <div className="row justify-content-md-center align-items-center">
          <span className="m-2">Chat on:</span>
          <span className="m-2">
            <a
              href={`https://www.youtube.com/watch?v=${video.videoId}`}
              target="_blank"
              rel="noopener noreferrer"
              title="On Dot NET Live playlist on YouTube"
            >
              <img
                className="img-fluid channel-icon forced-color-none"
                src={YoutubeLogo}
                alt=""
                role="presentation"
              />
            </a>
          </span>
          <span className="m-2">
            <a
              href="https://twitch.tv/VisualStudio"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="img-fluid channel-icon forced-color-none"
                src={TwitchLogo}
                alt=""
                role="presentation"
              />
            </a>
          </span>
        </div>
      </>
    );
  }
}

OnAir.propTypes = {
  video: VideoPropTypes.isRequired
};

export default OnAir;
